import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";

const BlogShow = () => {
  const location = useLocation();
  const Navigate = useNavigate();
  const [data, setData] = useState({});
  const [status, setStatus] = useState("");

  const GetUserData = () => {
    axios
      .get(`${process.env.REACT_APP_URL}/admin/blog/${location?.state?.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((res) => {
        setData(res?.data?.data);

        if (res.status === 200) {
        }
      })
      .catch((err) => {

        const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
        const STATUS = [401, 403];
        if (
          STATUS.includes(err.response.status) ||
          MSG.includes(err.response.data.msg)
        ) {
          localStorage.clear();
          Navigate("/admin/login");
        } else {
          toast.error(err?.response?.data?.msg);
        }
      });
  };

  useEffect(() => {
    if (location?.state === null) {
      Navigate("/admin/dashboard");
    } else {
      GetUserData();
      // setName(location?.state?.name);
      // setStatus(location?.state?.status);
    }
  }, []);

  return (
    <div className="al">
      <div className="al-head">
        <div>
          <h1 className="al-title">Blog Details</h1>
          <p className="al-sub">View this blog post.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <div className="al-idbanner">
        {data?.image_path ? (
          <img className="al-idbanner__icon" src={`${process.env.REACT_APP_IMAGE_URL}/uploads/${data.image_path}`} alt={data?.title}
            style={{ objectFit: "cover" }} onError={(e) => { e.currentTarget.style.display = "none"; }} />
        ) : (
          <div className="al-idbanner__icon">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /></svg>
          </div>
        )}
        <div>
          <div className="al-idbanner__name">{data?.title || "—"}</div>
          <div className="al-idbanner__sub">By {data?.author_name || "—"}</div>
        </div>
      </div>

      <div className="al-card">
        <div className="al-cardhead">
          <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /></svg></div>
          <h3 className="al-cardhead__title">Blog Information</h3>
        </div>
        <div className="al-spec">
          <div>
            <div className="al-spec__lbl">Title</div>
            <div className="al-spec__val">{data?.title || "—"}</div>
          </div>
          <div>
            <div className="al-spec__lbl">Author Name</div>
            <div className="al-spec__val">{data?.author_name || "—"}</div>
          </div>
          <div>
            <div className="al-spec__lbl">Tag</div>
            <div className="al-spec__val">{data?.tags || "—"}</div>
          </div>
          <div>
            <div className="al-spec__lbl">Slug</div>
            <div className="al-spec__val">{data?.slug || "—"}</div>
          </div>
          <div>
            <div className="al-spec__lbl">Date &amp; Time</div>
            <div className="al-spec__val">{data?.date_time || "—"}</div>
          </div>
          <div className="al-spec__full">
            <div className="al-spec__lbl">Description</div>
            <div className="al-spec__val">{data?.description?.replace(/<[^>]+>/g, "") || "—"}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogShow;
